import React from "react";
import { Clock, Folder, X } from "lucide-react";

function fmtTime(ts) {
  if (!ts) return "";
  const diff = Date.now() - ts;
  const s = Math.floor(diff / 1000);
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export default function RecentProjectsList({ items, onOpen, onRemove, currentId }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="border-b border-ide-border" data-testid="recent-projects">
      <div className="px-3 py-1.5 flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-ide-mute">
        <Clock className="h-3 w-3" /> Recent
      </div>
      <div className="px-2 pb-2 flex flex-col gap-0.5">
        {items.map((p) => (
          <div
            key={p.id}
            className={
              "group flex items-center gap-2 px-2 py-1.5 rounded-md transition-colors " +
              (p.id === currentId ? "bg-ide-surface" : "hover:bg-ide-panel")
            }
            data-testid={`recent-${p.id}`}
          >
            <button
              onClick={() => onOpen?.(p.id)}
              className="flex-1 text-left min-w-0 min-h-[32px] flex flex-col justify-center"
            >
              <div className="flex items-center gap-2">
                <Folder className="h-3 w-3 text-ide-accent flex-none" />
                <span className="truncate text-ide-text text-[13px]">{p.name}</span>
              </div>
              <div className="text-[10px] text-ide-mute font-mono truncate mt-0.5">
                {p.language} · {fmtTime(p.openedAt)}
              </div>
            </button>
            <button
              onClick={() => onRemove?.(p.id)}
              className="flex-none opacity-0 group-hover:opacity-100 text-ide-mute hover:text-rose-300 p-1 rounded hover:bg-rose-500/10 transition-opacity"
              title="Remove from recent"
              data-testid={`recent-remove-${p.id}`}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
